export default __webpack_public_path__ + "static/media/plan_image.49369595.png";